import axios from 'axios';

const AXIOS1= axios.create({
  baseURL: `https://10.60.131.232:8080/`,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export default AXIOS1;